import React from 'react'
import { SIDE_NAV_WIDTH, SIDE_NAV_COLLAPSED_WIDTH, NAV_TYPE_TOP } from 'constants/ThemeConstant';
import { APP_NAME } from 'configs/AppConfig';
import { connect } from "react-redux";
import utils from 'utils';
import { Grid } from 'antd';
import SkeletonAvatar from 'antd/lib/skeleton/Avatar';
import { Link } from 'react-router-dom';

const { useBreakpoint } = Grid;

const getLogoWidthGutter = (props, isMobile) => {
  const { navCollapsed, navType } = props;
  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  if (isMobile && !props.mobileLogo) {
    return 0
  }
  if (isNavTop) {
    return 'auto'
  }
  if (navCollapsed) {
    return `${SIDE_NAV_COLLAPSED_WIDTH}px`
  } else {
    return `${SIDE_NAV_WIDTH}px`
  }
}

const getLogo = (props) => {
  const { navCollapsed, logoType, } = props;
  if (logoType === 'light') {
    if (navCollapsed) {
      return '/img/One-ATS.svg'
    }
    return '/img/One-ATS.svg'
  }

  if (navCollapsed) {
    return props.logo
  }
  return props.logo
}

const getLogoDisplay = (isMobile, mobileLogo) => {
  if (isMobile && !mobileLogo) {
    return 'd-none'
  } else {
    return 'logo'
  }
}

export const Logo = (props) => {
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')
  // console.log(props)
  return (
    <>
      {
        props.logoActive?
        <>
          {
            props.isCompany ?
            <Link to={props.companyLink}
              className={getLogoDisplay(isMobile, props.mobileLogo)}
              style={{ width: `${getLogoWidthGutter(props, isMobile)}` }}>
              <img src={getLogo(props)} alt={`${APP_NAME} logo`}  />
            </Link> 
            :
            <Link to={`${props.logoLink?props.logoLink:'/'}`}
              className={getLogoDisplay(isMobile, props.mobileLogo)}
              style={{ width: `${getLogoWidthGutter(props, isMobile)}` }}>
              <img src={getLogo(props)} alt={`${APP_NAME} logo`}  />
            </Link> 
          }
        </>
          :
           <div className='pl-3 d-flex align-items-center mt-3'>
             <SkeletonAvatar/>
          </div>   
      }
    </>

  )
}

const mapStateToProps = ({ theme, auth }) => {
  const { navCollapsed, navType } = theme;
  const { logo, logoActive,logoLink } = auth
  return { navCollapsed, navType, logo, logoActive,logoLink }
};


export default connect(mapStateToProps)(Logo);
